import SendToTerminal from './SendToTerminal';

export default SendToTerminal;